import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import { useNavigate } from "react-router-dom";

import TopButton from "components/topbutton/TopButton";
import * as EgovNet from 'api/fetch';

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "styles/scss/business.scss";
import noImage from "images/business/noImage.jpg";
import waitImage from "images/business/waitImage.jpg";

function Business() {

    const navigate = useNavigate();
  
    const [isCompanyDropdownOpen, setIsCompanyDropdownOpen] = useState(false);
    // 재난안전
    const [disasterSafety, setDisasterSafety] = useState([]);
    // 클라우드
    const [cloud, setCloud] = useState([]);
    // 교육기관
    const [education, setEducation] = useState([]);
    // 위치기반
    const [LbsIot, setLbsIot] = useState([]);
    // 스마트팜
    const [smartFarm, setSmartFarm] = useState([]);
    // 기타
    const [etc, setEtc] = useState([]); 

    useEffect(() => {
        // Spring Boot API 호출
        const fetchJobs = async () => {
            const retrieveListURL = "/api/business"; // API 엔드포인트
            const requestOptions = {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                },
            };
            EgovNet.requestFetch(
                retrieveListURL,
                requestOptions,
                (resp) => {
                    // 성공적으로 데이터를 가져왔을 때
                    const data = resp.result.etbls.resultList || [];

                    // 재난안전
                    let disasterData = data.filter((item) => item.bizSe === "JT01");
                    while (disasterData.length < 4) {
                        disasterData.push({
                            etblTtl: "",
                            etblCn: `<img src="${waitImage}" alt="대기 이미지" />`,
                            expln: "",
                            bizYrPrd: "",
                        });
                    }
                    setDisasterSafety(disasterData);

                    // 재난안전
                    let cloudData = data.filter((item) => item.bizSe === "JT06");
                    while (cloudData.length < 4) {
                        cloudData.push({
                            etblTtl: "",
                            etblCn: `<img src="${waitImage}" alt="대기 이미지" />`,
                            expln: "",
                            bizYrPrd: "",
                        });
                    }
                    setCloud(cloudData);


                    // 교육
                    let eduData = data.filter((item) => item.bizSe === "JT02");
                    while (eduData.length < 4) {
                        eduData.push({
                            etblTtl: "",
                            etblCn: `<img src="${waitImage}" alt="대기 이미지" />`,
                            expln: "",
                            bizYrPrd: "",
                        });
                    }
                    setEducation(eduData);

                    // 위치기반
                    let LbsIotData = data.filter((item) => item.bizSe === "JT03");
                    while (LbsIotData.length < 4) {
                        LbsIotData.push({
                            etblTtl: "",
                            etblCn: `<img src="${waitImage}" alt="대기 이미지" />`,
                            expln: "",
                            bizYrPrd: "",
                        });
                    }                    
                    setLbsIot(LbsIotData);

                    // 스마트팜
                    let sfData = data.filter((item) => item.bizSe === "JT04");
                    while (sfData.length < 4) {
                        sfData.push({
                            etblTtl: "",
                            etblCn: `<img src="${waitImage}" alt="대기 이미지" />`,
                            expln: "",
                            bizYrPrd: "",
                        });
                    }
                    setSmartFarm(sfData);

                    // 기타
                    let etcData = data.filter((item) => item.bizSe === "JT05");
                    while (etcData.length < 4) {
                        etcData.push({
                            etblTtl: "",
                            etblCn: `<img src="${waitImage}" alt="대기 이미지" />`,
                            expln: "",
                            bizYrPrd: "",
                        });
                    }
                    setEtc(etcData);
                },
                (error) => {
                    // 에러 처리
                    console.error("Error fetching business data:", error);
                }
            );
        };

        fetchJobs();
    }, []);

    const stripHtmlTags = (html) => {
        if (!html) return ''; // null 또는 undefined 처리
        
        return html
        .replace(/<\/p>/gi, '\n') // </p> 태그를 줄바꿈으로 대체
        .replace(/<p[^>]*>/gi, '') // <p> 태그 제거
        .replace(/<br\s*\/?>/gi, '\n') // <br> 태그를 줄바꿈으로 대체
        .replace(/<\/?[^>]+(>|$)/g, '') // 나머지 태그 제거
        .replace(/\n\s*\n/g, '\n') // 연속된 줄바꿈을 하나로 축소
        .trim(); // 앞뒤 공백 제거
    };

    // 사업명 클릭 이벤트
    const etblClick = (pstId) => () => {
        if(!pstId) {
            alert('더나은 서비스를 위해 준비하고 있습니다.');
            return; // pstId가 없으면 클릭 이벤트 무시
        }
        const retrieveListURL = `/api/view/${pstId}`;
        const requestOptions = {
            method: "POST",
            headers: {
                'Content-type': 'application/json',
            }
        };

        EgovNet.requestFetch(retrieveListURL,
            requestOptions,
            (resp) => {
                // 소식
                navigate(`/business/${pstId}`);
            }
        );
    }

    return (
        <>
            <div className="infor-background">
                <TopButton />
                <h1>비즈니스</h1>
                <p> [재난안전 / 클라우드 / 위치기반&IoT / 교육기관 /스마트팜 / 기타]</p>
                {/* 브레드크럼 */}
                <div className="breadcrumb-box container">
                <nav className="breadcrumb">
                    <ul>
                        <li className="home-icon">
                            <Link to="/">
                                <span className="home"></span>
                            </Link>
                        </li>                
                        <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                            비즈니스
                        <span className="dropdown-icon">
                            {isCompanyDropdownOpen ? "▲" : "▼"}
                        </span>
                        {isCompanyDropdownOpen && (
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/about">회사소개</Link>
                            </li>
                            <li>
                                <Link to="/business">비즈니스</Link>
                            </li>
                            <li>
                                <Link to="/news">N소식</Link>
                            </li>
                            <li>
                                <Link to="/recruitment">인재채용</Link>
                            </li>
                            </ul>
                        )}
                    </li>
                </ul>
            </nav>
            <div className="mobile">
                <ul>
                    <li className="home-icon">
                        <Link to="/">
                            <span className="home"></span>
                        </Link>
                    </li>
                    <li className="dropdown" onClick={() => setIsCompanyDropdownOpen(!isCompanyDropdownOpen)}>
                            비즈니스
                        <span className="dropdown-icon">
                            {isCompanyDropdownOpen ? "▲" : "▼"}
                        </span>
                        {isCompanyDropdownOpen && (
                        <ul className="dropdown-menu">
                            <li>
                                <Link to="/about">회사소개</Link>
                            </li>
                            <li>
                                <Link to="/business">비즈니스</Link>
                            </li>
                            <li>
                                <Link to="/news">N소식</Link>
                            </li>
                            <li>
                                <Link to="/recruitment">인재채용</Link>
                            </li>
                        </ul>
                        )}
                    </li>
                </ul>
            </div>
            </div>
        </div>
        <div className="business-con">
            <div className="container">
                <ul>
                    <li className="tit">
                        {/* 활용스토리 or 실제적용사례 or 구축사례 중에 하나 쓰기 */}
                        <h2>실제적용사례</h2>
                        <div>"성공적인 구축사례를 통해 <span className="red">혁신적인 솔루션과 차별화된 기술력</span>을 확인하세요."</div>
                    </li>
                    {/* 구축사례 */}
                    <li className="case-group">
                        <ul className="business-group">
                            {/* 재난안전 -------------------------------------------- */}
                            <li className="titBoxAndSwiperBox">
                                <div className="li-box">
                                    <div className="icon01"></div>
                                    <h2 className="icon01-mobile">재난안전</h2>
                                    <p>스마트한 재난 안전 솔루션을 경험하세요!</p>
                                </div>
                                <div className="swiper-box">
                                    <Swiper
                                        spaceBetween={5}
                                        slidesPerView={1}
                                        pagination={{ clickable: true }}
                                        navigation={{
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        }}
                                        grabCursor={true}
                                        breakpoints={{
                                            320: { slidesPerView: 1 },
                                            480: { slidesPerView: 1 },
                                            768: { slidesPerView: 1 },
                                            1024: { slidesPerView: 3 },
                                            1280: { slidesPerView: 4 },
                                        }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        {disasterSafety.map((item, index) => (
                                        <SwiperSlide className="SwiperSlide" key={item.etblId || index}>
                                            <div className="swiper-box-g" onClick={etblClick(item.etblId)}>
                                                {/* 사업 타이틀 */}
                                                <p className="swiper-tit">{item.etblTtl || ''}</p>
                                                {/* 사업 이미지 */}
                                                <div className="swiper-img">
                                                {item.thumbnailUrl ? (
                                                    <img src={item.thumbnailUrl} alt="이미지" />
                                                ) : (
                                                    <img src={noImage} alt="빈 이미지" />
                                                )}
                                                </div>
                                                {/* 사업 내용 */}
                                                <p className="swiper-p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: stripHtmlTags(item.bizNm).replace(/\n/g, '<br />'),
                                                    }}                                                    
                                                ></p>
                                                {/* 04.02 날짜 최대 2개까지 추가 */}
                                                <div className="day-group">
                                                    {item.bizYrPrd &&
                                                    <div className="date-box">
                                                        <span>{item.bizYrPrd}</span>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        ))}
                                        <div className="swiper-button-next"></div>
                                        <div className="swiper-button-prev"></div>
                                    </Swiper>
                                </div>
                            </li>
                             {/* 클라우드 -------------------------------------------- */}
                             <li className="titBoxAndSwiperBox">
                                <div className="li-box swiper-mobile">
                                    <div className="icon02"></div>
                                    <h2 className="icon06-mobile">클라우드</h2>
                                    <p>변화는 불가피합니다. 준비된 기업만이 기회로 바꿀 수 있습니다. 미래에 투자하세요</p>
                                </div>
                                <div className="swiper-box">
                                    <Swiper
                                        spaceBetween={5}
                                        slidesPerView={1}
                                        pagination={{ clickable: true }}
                                        navigation={{
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        }}
                                        grabCursor={true}
                                        breakpoints={{
                                            320: { slidesPerView: 1 },
                                            480: { slidesPerView: 1 },
                                            768: { slidesPerView: 1 },
                                            1024: { slidesPerView: 3 },
                                            1280: { slidesPerView: 4 },
                                        }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        {cloud.map((item, index) => (
                                        <SwiperSlide className="SwiperSlide" key={item.etblId || index}>
                                            <div className="swiper-box-g" onClick={etblClick(item.etblId)}>
                                                {/* 사업 타이틀 */}
                                                <p className="swiper-tit">{item.etblTtl || ''}</p>
                                                {/* 사업 이미지 */}
                                                <div className="swiper-img">
                                                {item.thumbnailUrl ? (
                                                    <img src={item.thumbnailUrl} alt="이미지" />
                                                ) : (
                                                    <img src={noImage} alt="빈 이미지" />
                                                )}
                                                </div>
                                                {/* 사업 내용 */}
                                                <p className="swiper-p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: stripHtmlTags(item.bizNm).replace(/\n/g, '<br />'),
                                                    }}
                                                ></p>
                                                {/* 04.02 날짜 최대 2개까지 추가 */}
                                                <div className="day-group">
                                                    {item.bizYrPrd &&
                                                    <div className="date-box">
                                                        <span>{item.bizYrPrd}</span>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        ))}
                                        <div className="swiper-button-next"></div>
                                        <div className="swiper-button-prev"></div>
                                    </Swiper>
                                </div>
                                <div className="li-box li-box02">
                                    <div className="icon06"></div>
                                    <h2>클라우드</h2>
                                    <p>변화는 불가피합니다. <br></br>준비된 기업만이 기회로 바꿀 수 있습니다. <br></br>미래에 투자하세요</p>
                                </div>
                            </li>
                            {/* 위치기반 & IOT -------------------------------------------- */}
                            <li className="titBoxAndSwiperBox">
                                <div className="li-box">
                                    <div className="icon03"></div>
                                    <h2 className="icon03-mobile">위치기반 & IoT</h2>
                                    <p>실시간 위치 데이터로 더 똑똑한 세상을 만드세요!</p>
                                </div>
                                <div className="swiper-box">
                                    <Swiper
                                        spaceBetween={5}
                                        slidesPerView={1}
                                        pagination={{ clickable: true }}
                                        navigation={{
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        }}
                                        grabCursor={true}
                                        breakpoints={{
                                            320: { slidesPerView: 1 },
                                            480: { slidesPerView: 1 },
                                            768: { slidesPerView: 1 },
                                            1024: { slidesPerView: 3 },
                                            1280: { slidesPerView: 4 },
                                        }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        {LbsIot.map((item, index) => (
                                        <SwiperSlide className="SwiperSlide" key={item.etblId || index}>
                                            <div className="swiper-box-g" onClick={etblClick(item.etblId)}>
                                                {/* 사업 타이틀 */}
                                                <p className="swiper-tit">{item.etblTtl || ''}</p>
                                                {/* 사업 이미지 */}
                                                <div className="swiper-img">
                                                {item.thumbnailUrl ? (
                                                    <img src={item.thumbnailUrl} alt="이미지" />
                                                ) : (
                                                    <img src={noImage} alt="빈 이미지" />
                                                )}
                                                </div>
                                                {/* 사업 내용 */}
                                                <p className="swiper-p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: stripHtmlTags(item.bizNm).replace(/\n/g, '<br />'),
                                                    }}
                                                ></p>
                                                {/* 04.02 날짜 최대 2개까지 추가 */}
                                                <div className="day-group">
                                                    {item.bizYrPrd &&
                                                    <div className="date-box">
                                                        <span>{item.bizYrPrd}</span>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        ))}
                                        <div className="swiper-button-next"></div>
                                        <div className="swiper-button-prev"></div>
                                    </Swiper>
                                </div>
                            </li>
                            {/* 교육 -------------------------------------------- */}
                            <li className="titBoxAndSwiperBox">
                                <div className="li-box swiper-mobile">
                                    <div className="icon02"></div>
                                    <h2 className="icon02-mobile">교육기관</h2>
                                    <p>더욱 안정적이고 효율적인 학습환경을 위한 디지털 허브를 구축합시다!</p>
                                </div>

                                <div className="swiper-box">
                                    <Swiper
                                        spaceBetween={5}
                                        slidesPerView={1}
                                        pagination={{ clickable: true }}
                                        navigation={{
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        }}
                                        grabCursor={true}
                                        breakpoints={{
                                            320: { slidesPerView: 1 },
                                            480: { slidesPerView: 1 },
                                            768: { slidesPerView: 1 },
                                            1024: { slidesPerView: 3 },
                                            1280: { slidesPerView: 4 },
                                        }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        {education.map((item, index) => (
                                        <SwiperSlide className="SwiperSlide" key={item.etblId || index}>
                                            <div className="swiper-box-g" onClick={etblClick(item.etblId)}>
                                                {/* 사업 타이틀 */}
                                                <p className="swiper-tit">{item.etblTtl || ''}</p>
                                                {/* 사업 이미지 */}
                                                <div className="swiper-img">
                                                {item.thumbnailUrl ? (
                                                    <img src={item.thumbnailUrl} alt="이미지" />
                                                ) : (
                                                    <img src={noImage} alt="빈 이미지" />
                                                )}
                                                </div>
                                                {/* 사업 내용 */}
                                                <p className="swiper-p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: stripHtmlTags(item.bizNm).replace(/\n/g, '<br />'),
                                                    }}
                                                ></p>
                                                {/* 04.02 날짜 최대 2개까지 추가 */}
                                                <div className="day-group">
                                                    {item.bizYrPrd &&
                                                    <div className="date-box">
                                                        <span>{item.bizYrPrd}</span>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        ))}
                                        <div className="swiper-button-next"></div>
                                        <div className="swiper-button-prev"></div>
                                    </Swiper>
                                </div>
                                <div className="li-box li-box02">
                                    <div className="icon02"></div>
                                        <h2>교육기관</h2>
                                        <p>더욱 안정적이고 효율적인 학습환경을 위한 디지털 허브를 구축합시다!</p>
                                </div>
                            </li>
                            {/* 스마트팜 -------------------------------------------- */}
                            <li className="titBoxAndSwiperBox">
                                <div className="li-box">
                                    <div className="icon05"></div>
                                    <h2 className="icon05-mobile">스마트팜</h2>
                                    <p>스마트한 농업 솔루션으로 미래를 재배하세요!</p>
                                </div>
                                <div className="swiper-box">
                                    <Swiper
                                        spaceBetween={5}
                                        slidesPerView={1}
                                        pagination={{ clickable: true }}
                                        navigation={{
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        }}
                                        grabCursor={true}
                                        breakpoints={{
                                            320: { slidesPerView: 1 },
                                            480: { slidesPerView: 1 },
                                            768: { slidesPerView: 1 },
                                            1024: { slidesPerView: 3 },
                                            1280: { slidesPerView: 4 },
                                        }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        {smartFarm.map((item, index) => (
                                        <SwiperSlide className="SwiperSlide" key={item.etblId || index}>
                                            <div className="swiper-box-g" onClick={etblClick(item.etblId)}>
                                                {/* 사업 타이틀 */}
                                                <p className="swiper-tit">{item.etblTtl || ''}</p>
                                                {/* 사업 이미지 */}
                                                <div className="swiper-img">
                                                {item.thumbnailUrl ? (
                                                    <img src={item.thumbnailUrl} alt="이미지" />
                                                ) : (
                                                    <img src={noImage} alt="빈 이미지" />
                                                )}
                                                </div>
                                                {/* 사업 내용 */}
                                                <p className="swiper-p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: stripHtmlTags(item.bizNm).replace(/\n/g, '<br />'),
                                                    }}
                                                ></p>
                                                {/* 04.02 날짜 최대 2개까지 추가 */}
                                                <div className="day-group">
                                                    {item.bizYrPrd &&
                                                    <div className="date-box">
                                                        <span>{item.bizYrPrd}</span>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        ))}                    
                                        <div className="swiper-button-next"></div>
                                        <div className="swiper-button-prev"></div>
                                    </Swiper>
                                </div>
                                </li>
                            {/* 기타 -------------------------------------------- */}
                            <li className="titBoxAndSwiperBox">
                                <div className="li-box swiper-mobile">
                                    <div className="icon04"></div>
                                    <h2 className="icon04-mobile">기타</h2>
                                    <p>안정적인 시스템 구축으로 신뢰받는 행정 환경을 만듭니다.</p>
                                </div>
                                <div className="swiper-box">
                                    <Swiper
                                        spaceBetween={5}
                                        slidesPerView={1}
                                        pagination={{ clickable: true }}
                                        navigation={{
                                            nextEl: ".swiper-button-next",
                                            prevEl: ".swiper-button-prev",
                                        }}
                                        grabCursor={true}
                                        breakpoints={{
                                            320: { slidesPerView: 1 },
                                            480: { slidesPerView: 1 },
                                            768: { slidesPerView: 1 },
                                            1024: { slidesPerView: 3 },
                                            1280: { slidesPerView: 4 },
                                        }}
                                        modules={[Pagination, Navigation]}
                                    >
                                        {etc.map((item, index) => (
                                        <SwiperSlide className="SwiperSlide" key={item.etblId || index}>
                                            <div className="swiper-box-g" onClick={etblClick(item.etblId)}>
                                                {/* 사업 타이틀 */}
                                                <p className="swiper-tit">{item.etblTtl || ''}</p>
                                                {/* 사업 이미지 */}
                                                <div className="swiper-img">
                                                {item.thumbnailUrl ? (
                                                    <img src={item.thumbnailUrl} alt="이미지" />
                                                ) : (
                                                    <img src={noImage} alt="빈 이미지" />
                                                )}
                                                </div>
                                                {/* 사업 내용 */}
                                                <p className="swiper-p"
                                                    dangerouslySetInnerHTML={{
                                                        __html: stripHtmlTags(item.bizNm).replace(/\n/g, '<br />'),
                                                    }}
                                                ></p>
                                                {/* 04.02 날짜 최대 2개까지 추가 */}
                                                <div className="day-group">
                                                    {item.bizYrPrd &&
                                                    <div className="date-box">
                                                        <span>{item.bizYrPrd}</span>
                                                    </div>
                                                    }
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        ))}
                                        <div className="swiper-button-next"></div>
                                        <div className="swiper-button-prev"></div>
                                    </Swiper>
                                </div>
                                <div className="li-box li-box02">
                                    <div className="icon04"></div>
                                        <h2>기타</h2>
                                        <p>안정적인 시스템 구축으로 신뢰받는 행정 환경을 만듭니다.</p>
                                </div>
                            </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}

export default Business;